import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { trackerManager } from '@hero/clients';
import { PAGE_PATTERNS } from '@hero/constants';

function getPageName(pathname) {
  const matchedPage = PAGE_PATTERNS.find(({ pattern }) => pattern.test(pathname));

  if (matchedPage) {
    return matchedPage.key;
  }

  return 'other';
}

function PageViewEventProvider() {
  const location = useLocation();

  useEffect(() => {
    const pageName = getPageName(location.pathname);

    trackerManager.emit('pageView', {
      page: pageName
    });
  }, [location.pathname]);

  return null;
}

export { PageViewEventProvider };
